import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useEffect, useRef } from 'react';
import { TUpdate } from 'domain/types';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { showSystemToast } from 'view/components/SystemToast';

export const useUpdateRecruiterPreferences = (): any => {
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );
  const silentRef = useRef(false);

  const { data, isLoading, status, error, send } = useRequest({
    url: '/api/v1/profile/recruiter',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const updateRecruiterPreferences = (body: any, silent = false) => {
    silentRef.current = silent;
    return send({ ...body, hasWorkPreferencesFilled: true });
  };

  useEffect(() => {
    if (isLoading || !data) return;
    update?.({ recruiterPreferencesData: data });
    if (!silentRef.current) {
      showSystemToast(
        'success',
        'Work Preferences Updated',
        'Your changes have been saved successfully.'
      );
    }
  }, [data, isLoading, update]);

  return {
    isLoading,
    error: error || null,
    updateRecruiterPreferences,
    status,
  };
};
